
const digest = '9b0bc88d22b6e87af701dec00c96e92a31be81e6b86a47e29e2a8bd8f4c07141';
const classes = {"wrapper":"_wrapper_101uf_1","border":"_border_101uf_4","content":"_content_101uf_13","header":"_header_101uf_18","openEntryName":"_openEntryName_101uf_25","controls":"_controls_101uf_36","cancelled":"_cancelled_101uf_46","cancelledTitle":"_cancelledTitle_101uf_50","cancelledTag":"_cancelledTag_101uf_54"};
const css = `._wrapper_101uf_1 {
  background: #fff;
}
._wrapper_101uf_1 ._border_101uf_4 {
  display: flex;
  flex-direction: row;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_101uf_1 ._border_101uf_4:first-of-type {
  border-top: 1px solid #eaedf3;
}
._wrapper_101uf_1 ._border_101uf_4 ._content_101uf_13 {
  flex: 1;
  display: flex;
  flex-direction: column;
}
._wrapper_101uf_1 ._border_101uf_4 ._content_101uf_13 ._header_101uf_18 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 12px;
  padding: 12px 0 0 0;
}
._wrapper_101uf_1 ._border_101uf_4 ._content_101uf_13 ._header_101uf_18 ._openEntryName_101uf_25 {
  font-size: 16px;
  font-weight: 500;
  gap: 15px;
  display: flex;
  align-items: center;
}
._wrapper_101uf_1 ._border_101uf_4 ._content_101uf_13 ._header_101uf_18 ._openEntryName_101uf_25 span {
  font-size: 12px;
  color: #ccc;
}
._wrapper_101uf_1 ._border_101uf_4 ._controls_101uf_36 {
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #eaedf3;
  gap: 15px;
  flex-direction: column;
}

._cancelled_101uf_46 {
  color: #999999;
}

._cancelledTitle_101uf_50 {
  text-decoration: line-through;
}

._cancelledTag_101uf_54 {
  font-size: 60%;
  color: #000;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  